<template>
    <div class="back" @click="back"></div>
</template>

<script>
    export default {
        name:"backBtn",
         methods:{
            back(){
                //清空内容页中的上下一节中的章节页id，这样从内容页返回章节页，再进入内容页重新存储上下一节中的章节id
                window.sessionStorage.setItem('currentChapterObj',null);
                let parentChapterLists = this.pathInfo.parentChapterLists;
                if(Array.isArray(parentChapterLists)&&parentChapterLists&&parentChapterLists.length >= 1){
                    this.pathInfo.parentChapter =  this.pathInfo.parentChapterLists.splice(parentChapterLists.length-1,1);
                    this.$emit('getParentChapterList');
                }
                
                this.$router.go(-1);//返回上一层
            }
        }
    }
</script>

<style scoped>
    .back{
        position: fixed;
        top: 19px;
        z-index: 8;
        right: 0;
        z-index: 8;
        width: 69px;
        height: 60px;
        border-radius: 12px;
        background:url('/images/fanhui.png') no-repeat center;
        background-size:contain;
        cursor:pointer;
    }
    .back img{
        width:100%;
    }
    .inner-circle {
        margin: 0 auto;
        width: 75%;
        height: 75%;
        margin-top: 10%;
        border-radius: 50%;
        background-color: #fff;
        text-align: center;
        line-height: 1.2;
    }
    .inner-circle .iconfont {
        color: #fe6b57;
        font-size: 42px;
        position: absolute;
        right: 20%;
        top: 13%;
    }
    @media screen and (max-width:768px){
        .back {
            position: fixed;
            top: 12px;
            right: 13px;
            z-index: 8;
            width: 45px;
            height: 45px;
            border-radius: 12px;
            /* background-color: #fe6b57; */
        }
        .inner-circle .iconfont{
            color: #fe6b57;
            font-size: 25px;
            position: absolute;
            right: 24%;
            top: 13%;
        }
    }
</style>